import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 66 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M44.4047 24.7252C44.4047 35.6235 35.5793 44.4505 24.7023 44.4505C13.8254 44.4505 5 35.6235 5 24.7252C5 13.8269 13.8254 5 24.7023 5C35.5793 5 44.4047 13.8269 44.4047 24.7252ZM49.4047 24.7252C49.4047 38.3806 38.3451 49.4505 24.7023 49.4505C11.0596 49.4505 0 38.3806 0 24.7252C0 11.0699 11.0596 0 24.7023 0C38.3451 0 49.4047 11.0699 49.4047 24.7252ZM43.9571 49.7172L41.1168 46.9007L46.7444 41.2148L49.5848 44.0312L62.3447 56.6837L65.185 59.5002L59.5574 65.1861L56.717 62.3697L43.9571 49.7172Z",
      fill: "#628497"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.48071 23.4072C9.49603 16.0769 15.43 10.1374 22.7535 10.1221V14.1221C17.6426 14.1374 13.496 18.2825 13.4807 23.4072H9.48071Z",
      fill: "#628497"
    }, null, -1)
  ])))
}
export default { render: render }